import React from 'react';
import { CreditCard, IdCard, Camera, FileCheck } from 'lucide-react';

const docs = [
  { Icon: CreditCard, title: 'PAN Card', desc: 'Of Proprietor / Company / Directors / Partners', mandatory: true },
  { Icon: IdCard, title: 'Aadhaar Card', desc: 'Of Proprietor / Directors / Partners', mandatory: true },
  { Icon: Camera, title: 'Passport Photo', desc: 'Of the authorised signatory — mandatory for filing', mandatory: true },
  { Icon: FileCheck, title: 'Cancelled Cheque', desc: 'Of the current or business bank account', mandatory: true },
];

const DocumentsRequired = () => (
  <section className="bg-white py-16 md:py-20" data-testid="documents-required">
    <div className="max-w-7xl mx-auto px-5 lg:px-10">
      <div className="max-w-2xl">
        <div className="text-xs uppercase tracking-wider text-[#F39200] font-semibold mb-3">Documents Required</div>
        <h2 className="text-3xl md:text-5xl font-extrabold text-neutral-900 leading-[1.1]">
          All you need is{' '}
          <span className="relative inline-block text-[#F39200]">4 documents
            <svg className="absolute -bottom-2 left-0 w-full" height="10" viewBox="0 0 180 10" fill="none">
              <path d="M2 7 C 50 1, 110 1, 178 6" stroke="#F39200" strokeWidth="2" strokeLinecap="round" fill="none" />
            </svg>
          </span>{' '}to get started
        </h2>
        <p className="mt-4 text-[15px] text-neutral-600 max-w-xl">
          No physical office visits. No cumbersome paperwork. Share these digitally and we handle the rest.
        </p>
      </div>

      <div className="mt-10 grid sm:grid-cols-2 gap-4">
        {docs.map(({ Icon, title, desc, mandatory }) => (
          <div key={title} className="bg-[#FAF2E8]/60 border border-black/5 rounded-2xl p-5 flex items-start gap-4 hover:border-[#F39200] transition-colors">
            <div className="w-12 h-12 rounded-xl bg-white shadow-sm text-[#F39200] flex items-center justify-center shrink-0">
              <Icon size={22} />
            </div>
            <div className="flex-1">
              <div className="flex items-center gap-2 flex-wrap">
                <div className="text-sm font-semibold text-neutral-900">{title}</div>
                {mandatory ? (
                  <span className="text-[10px] font-semibold uppercase tracking-wider text-[#F39200] bg-[#F39200]/10 px-2 py-0.5 rounded-full">Required</span>
                ) : (
                  <span className="text-[10px] font-semibold uppercase tracking-wider text-neutral-500 bg-neutral-100 px-2 py-0.5 rounded-full">If applicable</span>
                )}
              </div>
              <p className="mt-1 text-xs text-neutral-600">{desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default DocumentsRequired;
